import React from 'react'
import _, { forEach } from "lodash";
import { useState, useEffect } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { useContext } from 'react';
import { MainContext } from 'context/mainContext';
import { updateVisualPersonalDashboard } from 'services/mongoDB';
import { registerDashboardTemplate } from 'services/mongoDB';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { updateVisualUserDashboard } from 'services/mongoDB';
import DashboardTemplateItemNew from '../dashboards/DashboardTemplateItemNew';
import DashboardTemplateItemModal from '../dashboards/DashboardTemplateItemModal';
import { IconClose } from 'eva-component/ui/icon';

const WidthResponsive = WidthProvider(Responsive);

function ManageDashboardDnD({updateLayout, selectedTemplateItem, handleOnEditVisual, onEditVisual, handleCloseEditVisual, newUpdateCount, 
    handleSelectItem, evaDateFilters, handleRemoveKPI, handleLayoutChanges, handleDateRangesUpdate, ...props}) {
    const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    const [compactType, setCompactType] = useState("vertical");
    const [mounted, setMounted] = useState(false);
    const [toolbox, setToolbox] = useState({});
    const [layouts, setLayouts] = useState({});
    const [layoutsWithId, setLayoutsWithId] = useState({});
    const [withError, setWithError] = useState(false)
    const { 
        bgColor, 
        textColor,
        templateFinalSelectedTemplateItem, 
        setTemplateFinalSelectedTemplateItem
    } = useContext(MainContext);
    const [alert, setAlert] = useState(false);
    const [onEditName, setOnEditName] = useState(false)
    const [gridHeaderCount, setGridHeaderCount] = useState([])

    useEffect(() => {
        if(!layouts?.lg || !layouts?.lg.length > 0) {
            setLayoutsWithId(layouts)
            return
        }
        if (!layouts?.lg || !layoutsWithId?.lg) return;
    
        const updatedLg = layoutsWithId.lg.map((item) => {
            const match = layouts.lg.find((l) => l.i === item.i);
            return match
                ? {
                    ...item,
                    w: match.w,
                    h: match.h,
                    x: match.x,
                    y: match.y
                }
                : item;
        });
    
        setLayoutsWithId((prev) => ({
            ...prev,
            lg: updatedLg
        }));
        // console.log("layouts", layouts.lg)
        setTimeout(() => {
            handleLayoutChanges()
        }, 300)
    }, [layouts]);

    useEffect(() => {
        // console.log("layoutsWithId", layoutsWithId.lg)
        if(!layoutsWithId?.lg || !layoutsWithId?.lg.length > 0) {
            return
        }
        const originalFinalSelectedTemplateItem = templateFinalSelectedTemplateItem

        if(!originalFinalSelectedTemplateItem) return

        originalFinalSelectedTemplateItem.map((item) => {
            const layout = layoutsWithId.lg.find(i => i.my_row_id === item.my_row_id && parseInt(i.__cardIndex) === parseInt(item.__cardIndex))
            if(layout) {
                item.tempVisual = {
                    ...item.tempVisual,
                    "width": layout.w,
                    "height": layout.h,
                    "x": layout.x,
                    "y": layout.y,
                };
            }
        })  

        setTemplateFinalSelectedTemplateItem(originalFinalSelectedTemplateItem)
    },[layoutsWithId])

    useEffect(() => {
        // console.log(selectedTemplateItem)
        if (selectedTemplateItem && selectedTemplateItem.length > 0) 
        {
            const templateItemList = []
            const layoutWithIDs = layoutsWithId?.lg
            const item = {
                lg: selectedTemplateItem.map(function (item, i) 
                {
                    const newItem = { ...item };
              
                    const isGrid = newItem.visual_type === "Grid"
                    const grid = gridHeaderCount.find(g => g.i === i);
                    const headerCount = grid ? grid.headerCount : null;
                    const isUpdateWidth = isGrid && headerCount
                    // console.log(newItem)
                    if(newItem.tempVisual && !newItem.isSeparateCard)
                    {
                        const layout = layoutWithIDs && layoutWithIDs.find(i => i.my_row_id === newItem.my_row_id);
                        templateItemList.push(newItem)

                        if(layout) {
                            layout.i = i.toString()
                            return layout
                        }
                        const x = (newItem.tempVisual.x !== null && newItem.tempVisual.x !== undefined) ? newItem.tempVisual.x : 0;
                        const y = (newItem.tempVisual.y !== null && newItem.tempVisual.y !== undefined) ? newItem.tempVisual.y : i * 13;
                        const w = (newItem.tempVisual.width !== null && newItem.tempVisual.width !== undefined) ? newItem.tempVisual.width : 4;
                        const h = (newItem.tempVisual.height !== null && newItem.tempVisual.height !== undefined) ? newItem.tempVisual.height : 13;
                        // const x = layout.x ? layout.x : 0;
                        // const y = layout.y ? layout.y : i * 13;
                        // const w = layout?.w ? layout.w : 4;
                        // const h = layout?.h ? layout.h : 13;
                        
                        const res = {
                            x: x,
                            y: y,
                            w: w,
                            h: h,
                            i: i.toString(),
                            my_row_id: item.my_row_id,
                            __cardIndex: item.__cardIndex
                        };
                        // console.log(res)
                        return res
                    } else if (newItem.visual) {
                        const x = (newItem.visual.x !== null && newItem.visual.x !== undefined) ? newItem.visual.x : 0;
                        const y = (newItem.visual.y !== null && newItem.visual.y !== undefined) ? newItem.visual.y : i * 13;
                        const w = (newItem.visual.width !== null && newItem.visual.width !== undefined) ? newItem.visual.width : 4;
                        const h = (newItem.visual.height !== null && newItem.visual.height !== undefined) ? newItem.visual.height : 13;
                        
                        templateItemList.push(newItem)
                        return {
                            x: x,
                            y: y,
                            w: w,
                            h: h,
                            i: i.toString(),
                            my_row_id: item.my_row_id,
                            __cardIndex: item.__cardIndex
                        };
                    } else {
                        const x =  0
                        const y = i * 14
                        let w = 4
                        let h = 13

                        switch(item.visual_type)
                        {
                            case "Card":
                                w = 1;
                                h = 6;
                            break;
                            case "Pie Chart":
                                w = 4;
                                h = 20
                            break;
                            case "Line Chart":
                                w = 4;
                                h = 11;
                            break;
                            case "Bar Chart":
                                w = 4;
                                h = 11;
                            break;
                            case "Grid":
                                w = 4;
                                h = 15;
                            break;
                            default:
                                w = 4;
                                h = 11;
                        }
                        const position = findNextAvailablePosition(templateItemList.map(d => d.tempVisual), w, h, 12);

                        const visual = {
                            "width": w,
                            "height": h,
                            "x": position ? position.x : x,
                            "y": position ? position.y : y,
                        }

                        if(!item.isSeparateCard) item.tempVisual = visual   
                        else {
                            // console.log(item.tempVisual)
                            item.tempVisual = {
                                ...item.tempVisual,
                                "width": item.tempVisual?.width ? item.tempVisual.width : w,
                                "height": item.tempVisual?.height ? item.tempVisual.height : h,
                                "x": item.tempVisual?.x ? item.tempVisual.x : position ? position.x : x,
                                "y": item.tempVisual?.y ? item.tempVisual.y : position ? position.y : y,
                            };
                            templateItemList.push(item)
                            return {
                                x: item.tempVisual?.x ? item.tempVisual.x : position ? position.x : x,
                                y: item.tempVisual?.y ? item.tempVisual.y : position ? position.y : y,
                                w: item.tempVisual?.width ? item.tempVisual.width : w,
                                h: item.tempVisual?.height ? item.tempVisual.height : h,
                                i: i.toString(),
                                my_row_id: item.my_row_id,  
                                __cardIndex: item.__cardIndex
                            };
                        }

                        templateItemList.push(item)
                        return {
                            x: position ? position.x : x,
                            y: position ? position.y : y,
                            w: w,
                            h: h,
                            i: i.toString(),
                            my_row_id: item.my_row_id,
                            __cardIndex: item.__cardIndex
                        };
                    }
                })
            };
            // console.log(item)
            setLayoutsWithId(item)
            setLayouts(item);
        }

    }, [selectedTemplateItem, newUpdateCount, gridHeaderCount, updateLayout]);

    const findNextAvailablePosition = (layout, newItemWidth, newItemHeight, maxWidth = 12) => {
        try {
            const occupied = new Set();
    
            // Mark occupied positions in the grid
            layout.forEach(({ x, y, width, height }) => {
                for (let i = 0; i < width; i++) {
                    for (let j = 0; j < height; j++) {
                        occupied.add(`${x + i},${y + j}`);
                    }
                }
            });
        
            // Scan row by row for available space
            for (let y = 0; ; y++) {
                for (let x = 0; x <= maxWidth - newItemWidth; x++) {
                    let fits = true;
        
                    // Check if the new item can fit in this position
                    for (let i = 0; i < newItemWidth; i++) {
                        for (let j = 0; j < newItemHeight; j++) {
                            if (occupied.has(`${x + i},${y + j}`)) {
                                fits = false;
                                break;
                            }
                        }
                        if (!fits) break;
                    }
        
                    if (fits) return { x, y };
                }
            }
        } catch (error) {
        }
        
    };

    const handleGridHeaderChange = (gridHeaderCount) => {
        return
        setGridHeaderCount(prev => {
            const index = prev.findIndex(item => item.i === gridHeaderCount.i);
            
            if (index !== -1) {
                const updated = [...prev];
                updated[index].headerCount = gridHeaderCount.headerCount;
                return updated;
            }
    
            return [...prev, gridHeaderCount];
        });
    };
    

    useEffect(() => {
       
    },[newUpdateCount])

    useEffect(() => {
        setMounted(true);
    }, []);

    const onBreakpointChange = (breakpoint) => {
        setCurrentBreakpoint(breakpoint);
        setToolbox({
            ...toolbox,
            [breakpoint]: toolbox[breakpoint] || toolbox[currentBreakpoint] || [],
        });
    };

    const onLayoutChange = (layout, layouts) => {
        // console.log({layout, layouts})
        setLayouts({ ...layouts });
    };

    const onDrop = (layout, layoutItem, _ev) => {
        // console.log(`Element parameters:\n${JSON.stringify(layoutItem, ["x", "y", "w", "h"], 2)}`);
    };

    const onHandleEditVisual = (index, evaQuery) => {
        handleOnEditVisual(index, evaQuery)
    }
    const handleIsWithError = (value) => {
        setWithError(value)
    }
    const onHandleDeleteKPI = (my_row_id, index) => {
        layouts.lg.splice(index, 1);
        setLayouts(layouts)
        handleRemoveKPI(my_row_id)
    }
    const generateDOM = () => {
        return (
            selectedTemplateItem && selectedTemplateItem.length > 0 && selectedTemplateItem.map((item, index) => (
                <div key={index} style={{ background: item.visual_type === "Card" ? item.background || "#fff" : "#fff", zIndex: 999, overflow: 'hidden' }}>
                    {/* // className={"static"} */}
                    {/* {index} */}
                    <div className='deleteKPI'
                        onClick={() => onHandleDeleteKPI(item.my_row_id, index)}>
                        <IconClose /> 
                    </div>
                    <DashboardTemplateItemModal
                        index={index}
                        name={item.name}
                        query={item.query}
                        item={item}
                        newUpdateCount={newUpdateCount}
                        layoutsWithId={layoutsWithId}
                        selectedTemplateItem={selectedTemplateItem}
                        onEditVisual={onEditVisual}
                        handleCloseEditVisual={handleCloseEditVisual}
                        handleIsWithError={handleIsWithError}
                        onHandleEditVisual={onHandleEditVisual}
                        evaDateFilters={evaDateFilters}
                        handleGridHeaderChange={handleGridHeaderChange}
                        handleRemoveKPI={handleRemoveKPI}
                        handleDateRangesUpdate={handleDateRangesUpdate}
                    />
                </div>
            ))
        );
    };
    
    return (
        <>
            <div className={`mb-4`}>
                <WidthResponsive
                    {...props}
                    // style={{ background: "#fff" }}
                    layouts={layouts}
                    measureBeforeMount={false}
                    useCSSTransforms={mounted}
                    compactType={compactType}
                    preventCollision={!compactType}
                    onLayoutChange={onLayoutChange}
                    onBreakpointChange={onBreakpointChange}
                    onDrop={onDrop}
                    // isDroppable={props.editMode}
                >
                    {generateDOM()}
                </WidthResponsive>
            </div>
        </>
    );
}

export default ManageDashboardDnD

ManageDashboardDnD.defaultProps = {
    className: "layout",
    rowHeight: 30,
    onLayoutChange: (layout, layouts) => {},
    cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
    breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
    containerPadding: [0, 0],
  };